module.exports = __webpack_public_path__ + "static/media/edit.359e2264.svg";